import CandidaturePreviewRequest, {
  CandidaturePreviewRequestQueryParams,
} from "./candidature-preview.request";

const createQueryParams = (
  data: CandidaturePreviewRequest,
): CandidaturePreviewRequestQueryParams => {
  return {
    taxiDriverAssociationId: data.taxiDriverAssociationId || undefined,
    planEntryId: data.planEntryId || undefined,
  };
};

const candidaturePreviewRequestFactory = {
  createQueryParams,
};

export default candidaturePreviewRequestFactory;
